export default "__VITE_ASSET__CX75J1aR__"